export default __webpack_public_path__ + "static/media/seo.075d155c.svg";